function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Logos / Social / logo_facebook");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Logos-/-Social-/-logo_facebook",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.514062,62.9324729 C61.4014574,62.9324729 62.9319922,61.401938 62.9319922,59.514062 L62.9319922,4.41817054 C62.9319922,2.53005426 61.4016977,1 59.514062,1 L4.41817054,1 C2.53005426,1 1,2.53005426 1,4.41817054 L1,59.514062 C1,61.4016977 2.52981395,62.9324729 4.41817054,62.9324729 L59.514062,62.9324729 Z",
  id: "Blue_1_",
  fill: "#3C5A99",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.7321783,62.9324729 L43.7321783,38.9488062 L51.7823256,38.9488062 L52.9877209,29.6019457 L43.7321783,29.6019457 L43.7321783,23.6345659 C43.7321783,20.9284341 44.4836279,19.0842946 48.364155,19.0842946 L53.3135814,19.0821318 L53.3135814,10.7222248 C52.4575969,10.6083178 49.5195659,10.3538295 46.1013953,10.3538295 C38.9653876,10.3538295 34.0798837,14.7096899 34.0798837,22.7088915 L34.0798837,29.6019457 L26.0090698,29.6019457 L26.0090698,38.9488062 L34.0798837,38.9488062 L34.0798837,62.9324729 L43.7321783,62.9324729 Z",
  id: "f",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

var SvgLogoFacebook = function SvgLogoFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_facebook.3ee13d66.svg";
export { ForwardRef as ReactComponent };